import { ManagerNotificationEventData } from './server';

/** Топики глобальные, поэтому с префиксом домена. */
export enum PubSubManagerNotificationEvent {
  noteMentionsRead = 'managerNotifications/noteMentionsRead',
  userListFillReceived = 'managerNotifications/userListFillReceived',
  /** Пришло событие из личного канала; payload — ManagerNotificationEventData */
  received = 'managerNotifications/received'
}

/**
 * Открыт ли сейчас у оператора объект события: диалог, в который написали, или
 * карточка пользователя, в заметке которого упомянули.
 *
 * Реализуют сторы диалогов и карточки — они живут, только пока открыт свой
 * раздел, и в RootStore их нет, поэтому регистрируют предикат сами.
 *
 * Возвращает факт, а не запрет уведомления: при открытой карточке звук молчит,
 * но упоминание продолжает считаться, пока заметка не показалась на экране.
 */
export type ManagerNotificationOpenViewCheck = (
  data: ManagerNotificationEventData
) => boolean;

export type PubSubNoteMentionsReadData = {
  userId: string;
  noteIds: string[];
  /** Остались ли у ЭТОГО пользователя ещё непросмотренные упоминания */
  userHasUnreadMentions: boolean;
};

/**
 * Уровень индикатора вкладки. Приоритет: violation > warning > neutral > none.
 *
 * `neutral` — SLA спокоен, но есть непрочитанные или упоминания.
 * `none` — ни одного источника.
 */
export enum TabIndicatorLevel {
  violation = 'violation',
  warning = 'warning',
  neutral = 'neutral',
  none = 'none'
}

export enum TabIndicatorSource {
  slaViolation = 'sla_violation',
  slaWarning = 'sla_warning',
  unread = 'unread',
  mention = 'mention'
}

/**
 * Единый результат для favicon, заголовка вкладки и прочих потребителей: они не
 * должны считать приоритет каждый по-своему. Источники сохраняются все, чтобы
 * `neutral` не терял причину и чтобы новый источник добавлялся таблицей
 * приоритетов, а не второй параллельной структурой.
 */
export type ITabIndicator = {
  level: TabIndicatorLevel;
  sources: TabIndicatorSource[];
};
